import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const WORDMARK_BLUE = '/assets/logos/wordmark-blue.png';

const Ico = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

// linkPrefix: "#" when rendered on the landing page (same-page anchors),
// "/#" when rendered on external pages so links route back to the landing sections.
export const MarketingHeader = ({ linkPrefix = '#' }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const goSignup = () => navigate(user ? '/' : '/register');
  const goLogin = () => navigate(user ? '/' : '/login');
  const logoHref = linkPrefix === '#' ? '#top' : '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { href: `${linkPrefix}how`, label: 'How it works' },
    { href: `${linkPrefix}who`, label: "Who it's for" },
    { href: `${linkPrefix}story`, label: 'Why Milk' },
    { href: '/pricing', label: 'Pricing' },
  ];

  return (
    <header className={`nav${scrolled ? ' scrolled' : ''}`} data-testid="marketing-header">
      <div className="container nav-in">
        <a className="nav-logo" href={logoHref} aria-label="Milk home"><img src={WORDMARK_BLUE} alt="Milk" /></a>
        <nav className="nav-links" aria-label="Primary">
          {links.map(l => <a key={l.label} href={l.href}>{l.label}</a>)}
        </nav>
        <div className="nav-cta">
          <a className="signin" href="#" onClick={(e) => { e.preventDefault(); goLogin(); }} data-testid="marketing-signin-link">Sign in</a>
          <button className="btn btn-primary" onClick={goSignup} data-testid="marketing-get-started-nav">Get started</button>
          <button className="hamburger" aria-label="Menu" onClick={() => setMenuOpen(o => !o)}>
            <Ico><line x1="3" y1="7" x2="21" y2="7" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="17" x2="21" y2="17" /></Ico>
          </button>
        </div>
      </div>
      <nav className={`mnav${menuOpen ? ' open' : ''}`} aria-label="Mobile">
        {links.map(l => <a key={l.label} href={l.href} onClick={() => setMenuOpen(false)}>{l.label}</a>)}
        <a href="#" onClick={(e) => { e.preventDefault(); setMenuOpen(false); goLogin(); }}>Sign in</a>
        <button className="btn btn-primary" onClick={() => { setMenuOpen(false); goSignup(); }}>Get started free</button>
      </nav>
    </header>
  );
};

export default MarketingHeader;
